import * as apiUpdateMembershipPerks from '@/api/membershipPerks/updateMembershipPerks';

export default {
	namespaced: true,
	state: () => ({
		loading: false,
	}),
	mutations: {
		isLoading(state, loading) {
			state.loading = loading;
		},
	},
	actions: {
		async update({ commit }, membership) {
			commit('isLoading', true);

			await apiUpdateMembershipPerks.put(membership.id, membership);

			commit('isLoading', false);
		},
	},
	getters: {},
};
